import React from "react";

import { getSearchSeoTitle, unSlugify } from "utils/strings";
import { SearchResultsState } from "interfaces/context/searchResultsContextInterfaces";
import styles from "./Header.module.scss";

interface SearchHeaderProps {
    state: SearchResultsState;
    location: string | null;
    keyword: string | null;
    company: string | null;
    category: string | null;
}

const SearchHeader = (props: SearchHeaderProps) => {
    const {
        location, keyword, company, category, state
    } = props;
    const total = state.totalCount;

    const headerStringObj = getSearchSeoTitle(
        location,
        unSlugify(keyword),
        company,
        category,
        total,
    );

    return (
        <h1 className={styles.total}>
            {total > 0 && (<span>{headerStringObj.totalString}</span>)}
            {headerStringObj.suffix}
        </h1>
    );
};

SearchHeader.displayName = "SearchHeader";
export default SearchHeader;
